// ⚠️ GENERATED FILE — 請勿直接編輯。
// 來源：api/src/contracts/
// 修改方式：改動來源檔後執行 `cd api && npm run sync:contracts`
import { z } from 'zod'

/**
 * 登入圖形驗證碼。
 *
 * 流程：前端先打 `GET /api/v1/captcha` 拿 `{ id, svg }`，
 * 送出登入時一併帶上 `captchaId` 與使用者輸入的 `captchaAnswer`。
 * 後端驗證後**立即作廢**該張驗證碼，同一張不能用第二次。
 */

/** 4 位數字。與登入表單上顯示的位數一致 */
export const CAPTCHA_LENGTH = 4
export const CAPTCHA_PATTERN = /^\d{4}$/

/** 存活秒數。太短會讓慢慢打字的人一直失敗，太長則失去節流意義 */
export const CAPTCHA_TTL_SECONDS = 180

export const captchaAnswerSchema = z
  .string()
  .trim()
  .regex(CAPTCHA_PATTERN, { message: 'CAPTCHA_FORMAT' })

export const captchaChallengeSchema = z.object({
  id: z.string(),
  /** 完整 SVG 字串。前端不需要知道怎麼畫，也拿不到答案 */
  svg: z.string(),
  expiresIn: z.number().int().positive(),
})
export type CaptchaChallenge = z.infer<typeof captchaChallengeSchema>
